export default __webpack_public_path__ + "static/media/linearpot.c3f30424.png";